import React from "react";
import PropTypes from "prop-types";

import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import StreamCap from "stream/containers/StreamCap";
import FullStoryCard from "cards/containers/FullStoryCard";

import { DEFAULT_CARD_HEIGHT, SECTION } from "config/constants";

export default function TopSectionStream(props) {
  return (
    <SectionStreamWrapper {...props} slug={SECTION.TOP.slug}>
      {({ streamParams }) => {
        return (
          <React.Fragment>
            <StreamCap />
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
            />
          </React.Fragment>
        );
      }}
    </SectionStreamWrapper>
  );
}
